import * as yup from 'yup'

const required = 'This field is required'

export const validationSchema = yup.object().shape({
  action: yup.string().required(),
  street: yup.string().required(required),
  unit_number: yup.string().nullable(),
  city: yup.string().required(required),
  state: yup
    .string()
    .required(required)
    .test('max_length', '2 character valid state abbreviation required.', (val) => {
      if (val === undefined) {
        return true
      }
      return val.length === 0 || val.length < 5
    }),
  zip_code: yup.string().required(required),
  selected_avms: yup.array().min(1).required('At least one AVM must be selected.'),
})
